// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"335":"44e3ddd7","336":"feadbc47","352":"f61d1435","393":"37ed5c33","394":"26827ba7","467":"00968225","559":"2c9d7774","617":"db0692bb","619":"9a3ee152","692":"eb6d68e0","725":"2a054c55","759":"8b0f4f6a","760":"f4ca4cd8","789":"62107d3c","941":"cef3a096","956":"cf226917"}[chunkId] + ".js";
};